import React from "react";
import store from "../../Store";
import { toggleFailedSiteStatusModal } from "./FailedSite-Action"; // You'll need to create this
import SelectField from "../../components/shared/form/SelectField-phpVersion";
import axios from "axios";
import { apiBaseUrl } from "../../helpers/UrlHelper";
import { loginToken } from "../../helpers/LocalStorageHelper";
import { handleError, handleSuccess } from "../../helpers/ErrorHelper";
import { toggleFailedOrganizationStatusModal } from "../organization-failed-transactions/OgranizationFailed-Action";
import { toggleSiteFailedStatusModal } from "../organization-site-failed-transactions/SiteFailed-Action";
import { withRouter } from "react-router";
import getGlobalFailedTnx from "../../ajax/actions/failed-site-transactions/globalFailed-get";
import getOrganizationFailedTnx from "../../ajax/actions/failed-site-transactions/organizationFailed-get";
import getSiteFailedTnx from "../../ajax/actions/failed-site-transactions/siteFailed-get";

class UpdateStatus extends React.Component {
  state = {
    status: null,
  };

  onChange = (e) => {
    this.setState({ status: e?.target?.value });
  };

  updateStatusFormSubmit = (id, e) => {
    e.preventDefault();
    axios({
      url: apiBaseUrl(`admin/failed-site-transactions/${id}/update-status`),
      method: "put",
      dataType: "json",
      data: this.state,
      headers: { Authorization: "Bearer " + loginToken() },
    })
      .then((res) => {
        if (this.props.title === "Failed Organization") {
          store.dispatch(toggleFailedOrganizationStatusModal());
          store.dispatch(getOrganizationFailedTnx(this.props.match.params.id));
        } else if (this.props.title === "Failed Site") {
          store.dispatch(toggleFailedSiteStatusModal());
          store.dispatch(getGlobalFailedTnx());
        } else {
          store.dispatch(toggleSiteFailedStatusModal());
          store.dispatch(getSiteFailedTnx(this.props.match.params.id));
        }

        handleSuccess(res?.data?.message);
      })
      .catch((err) => {
        handleError(err?.data?.message);
      });
  };

  render() {
    const { id } = this.props;

    return (
      <div className="content-form-block light-gray-bg">
        <form
          className="mt-30 domain-form"
          onSubmit={(e) => this.updateStatusFormSubmit(id, e)}
        >
          <SelectField
            name="update_status"
            value={this.state.status}
            options={[
              { label: "Pending", value: "pending" },
              { label: "Acknowledged", value: "acknowledged" },
              { label: "Resolved", value: "resolved" },
            ]}
            label="Update Status"
            onChange={this.onChange}
            _value="value"
            _label="label"
          />

          <div className="button-wrapper inline-buttons text-center d-flex justify-content-center">
            <button
              className="btn-theme btn-outline"
              type="reset"
              onClick={() => store.dispatch(toggleFailedSiteStatusModal())}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!this.state.status}
              className="btn-theme radius-btn-blue"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(UpdateStatus);
